export const IMAGES_DB_INIT_VERSION = 1

// 상품 등록시 이미지 저장용 아이디
export const ITEMS_REGISTRATION_ID = 1
export const BRAND_ITEMS_REGISTRATION_ID = 2
export const TREND_ITEMS_REGISTRATION_ID = 3
